import { gql } from '@apollo/client';

export const QUERY_RESOURCE_BY_PAGE = gql`
  query QueryResourceByPage(
    $condition: ResourceQueryConditionInput
    $pageRequest: PageRequestTypeInput
  ) {
    queryResourceByPage(condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        code
        name
        type
        parentId
        parentName
        description
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface ResourceType {
  id: number | string;
  code: string;
  name: string;
  type: string; // "MENU" | "BUTTON"
  parentId?: number | string | null;
  parentName?: string | null;
  description?: string | null;
  createdAt?: number | string | null;
  updatedAt?: number | string | null;
}

export interface ResourceQueryConditionInput {
  id?: number | null;
  code?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface PageRequestType {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface ResourcePageResponseType {
  content: ResourceType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface QueryResourceByPageResponse {
  queryResourceByPage: ResourcePageResponseType;
}

export interface QueryResourceByPageVariables {
  condition?: ResourceQueryConditionInput | null;
  pageRequest?: PageRequestType | null;
}

